let env = {};

// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';
// env.webserviceHost = 'localhost';
// env.webservicePort = 6001;
// env.mode = 'homolog';

env.baseURL = 'https://api.central-vagas.it4d.com.br/api/v1/';
env.normalURL = 'https://central-vagas.it4d.com.br/';

export default env




